<template>
    <modal
        ref="picker"
        :is-hidden="currentPopup == null"
        :is-open="currentPopup != null"
        :title="$t(title)"
        size="lg"
        v-on:clickclose="closeDialog"
        :alert="alertTitle"
        :alert-style="alertStyle"
        :alert-text="alertText"
        :alert-icon="alertIcon"
        alert-dismissable
        v-on:dismissalert="closeDialog"
        v-on:close="closeDialog"
        :no-padding="true"
        :fixed="true"
    >
        <template slot="footer">
            <button v-if="editing && !readonly" type="button" class="float-left btn btn-danger" v-on:click="removeTooth"><i class="fa fa-times"></i> {{ $t('Action.remove') }}</button>
            <button v-if="!editing && !readonly && lastSelection" type="button" class="float-left btn btn-primary" v-on:click="useLastSelection"><i class="fa fa-history"></i> {{ $t('Action.usePrevious') }}</button>
            <button type="button" class="btn btn-default" v-on:click="closeDialog">{{ $t('Action.close') }}</button>
            <button v-if="!lastTab && !readonly" type="button" class="btn btn-default" :disabled="!badges[activeTab]" v-on:click="saveTooth">{{ $t('Action.next') }}<i class="fas fa-chevron-right"></i></button>
            <button v-if="lastTab && !readonly" type="button" class="btn btn-success" :disabled="!isReady()" v-on:click="saveTooth"><i v-if="actionIcon" :class="`fa fa-${actionIcon}`"></i> {{ $t(actionButton || 'Action.finish') }}</button>
            <div class="clear"></div>
        </template>

        <card :key="id" :body-class="bodyClass" v-on:change="handleChangeTab" :active-tab="activeTab" v-if="currentPopup">
            <cardtab v-for="(section, index) in sections"
                     :title="$t(section.label)"
                     :id="`${section.id || index}`"
                     :icon="section.icon"
                     :badge="(!section.form || section.form.length) ? badges[`${section.id || index}`] ? '✔' : '!' : undefined"
                     :badge-color="badges[`${section.id || index}`] ? 'success' : 'warning'"
                     style="padding: 16px;min-height: 550px"
                     class="non-validated"
                     v-if="(section.form && section.form.length) || section.productTree"
            >
                <div v-if="section.intro != null" :class="section.intro.style" v-html="$t(section.intro)"></div>

                <project-master-data-tab :form="getForm(section)"
                                         :formValues="currentPopup.values"
                                         :itemNums="currentPopup.itemnums"
                                         :hasOrder="readonly"
                                         :isEditable="!readonly"
                                         ref="form"
                                         v-if="section.form"
                                         v-on:input="handleFormInput"
                                         v-on:valid="(isValid) => handleBadge(`${section.id || index}`, isValid)"
                ></project-master-data-tab>

                <finder-popup
                        v-else-if="section.productTree"
                        ref="form"
                        :id="`finder_${section.id || index}`"
                        :formValues="currentPopup.values"
                        :itemNums="currentPopup.itemnums"
                        :selection="currentPopup.finder"
                        :product-tree="section.productTree"
                        v-on:input="handleFormInput"
                        v-on:valid="(isValid) => handleBadge(`${section.id || index}`, isValid)"
                        v-on:form="(form) => updateForm(`form_for_${section.id || index}`, form)"
                />
                <div v-else>{{section}}</div>

                <div v-if="section.outro != null" :class="section.outro.style" v-html="$t(section.outro)"></div>
            </cardtab>
        </card>
    </modal>
</template>
<script>
  import ProjectMasterDataTab from './ProjectMasterDataTab.vue';
  import ProductPickerMixin from '../Mixins/ProductPicker.js';
  import FormsMixin from '../Mixins/Forms.js';
  import FinderPopup from './FinderPopup.vue'

    export default {
      mixins: [ FormsMixin, ProductPickerMixin ],
      components: {
        ProjectMasterDataTab,
        FinderPopup,
      },
      data() {
        return {
          activeTab: `section_0`,
          currentPopup: null,
          editing: false,
          title: '',
          bodyClass: undefined,
          lastTab: false,
          badges: {},
          readonly: false,
          lastSelection: null,
          id: Date.now(),
          alertTitle: null,
          alertStyle: null,
          alertText: null,
          alertIcon: null,
          actionButton: 'Action.finish',
          actionIcon: 'check',
        }
      },
      computed: {
        sections() {
          const s = this.currentPopup.model;
          return [].concat(...s.map((x, idx) => x.productTree
            ? [x, {id: `form_for_${x.id || idx}`, form: [], label: x.formLabel}]
            : [x])).filter(x => x.form && x.form.length || x.productTree);
        }
      },
      methods: {
        getForm(section) {
          return section.form;
        },
        updateForm(id, form) {
          this.sections.forEach((x) => {
            if (x.id === id) {
              x.form = form;
              this.$forceUpdate();
            }
          })
        },
        handleFormInput(value, field) {

          if (this.getFieldItem(field, value)) {
            // this.updatePrices();
            return;
          }

          (this.$refs.form || []).forEach(x => x.refresh());

          setTimeout(() => {
            (this.$refs.form || []).forEach(x => x.refresh());
          }, 100);

          // this.formComplete = this.getFormStatus();
          this.$forceUpdate();
          this.isModified = Date.now();
        },
        // Get the item number from a form field
        getFieldItem(field, fieldValue) {
          switch (this.fieldType(field)) {
            case 'hidden':
            case 'checkbox':
              if (typeof field.itemnum != 'undefined') {
                if (typeof fieldValue == 'undefined') {
                  return true;
                }

                return fieldValue ? field.itemnum : false;
              }
              break;
            case 'select':
              for (let i in field.options) {
                if (field.options.hasOwnProperty(i)) {
                  if (typeof field.options[i] == 'object' && typeof field.options[i].value != 'undefined' && typeof field.options[i].itemnum != 'undefined') {
                    if (typeof fieldValue == 'undefined') {
                      return field.options[i].itemnum;
                    }
                    if (field.options[i].value == fieldValue) {
                      return field.options[i].itemnum;
                    }
                  }
                }
              }
              break;
          }

          return false;
        },
          closeDialog() {
            if (this.currentPopup && this.handler) {
              const {layer, range} = this.currentPopup;
              this.handler(!this.editing ? 'remove' : 'close', layer, range);
            }

            this.currentPopup = null;
          },
          openDialog(model, selection, {editing, title, bodyClass, readonly, lastSelection, action = 'Action.finish', icon = 'check'}, handler) {
            this.id = Date.now();
            this.handler = handler;
            this.editing = editing;
            this.title = title;
            this.bodyClass = bodyClass;
            this.badges = {};
            this.readonly = !!readonly;
            this.lastSelection = lastSelection;
            this.currentPopup = Object.assign({model}, selection);
            this.actionButton = action;
            this.actionIcon = icon;
            this.handleChangeTab(null);
            this.$forceUpdate();
          },
          useLastSelection() {
            if (this.lastSelection) {
              const {layer, range} = this.currentPopup;
              const {values, itemnums, finder, sections} = this.lastSelection;
              this.handler('save', layer, range, values, itemnums, finder, sections);
            }

            this.currentPopup = null;
          },
          saveTooth() {
            const tabs = this.sections.map(({id}, i) => `${id || i}`);
            if (!this.lastTab) {
              this.handleChangeTab(tabs[1 + tabs.indexOf(this.activeTab)])
              return ;
            }

            if (this.currentPopup && this.handler) {
              const {layer, range, values, finder, itemnums: original} = this.currentPopup;
              const sections = [].concat(...this.$refs.form.map(x => x.getItemNums())).filter(x => x);
              this.handler('save', layer, range, values, original, finder, sections);
            }

            this.currentPopup = null;
          },
          removeTooth() {
            if (this.currentPopup && this.handler) {
              const {layer, range} = this.currentPopup;
              this.handler('remove', layer, range);
            }

            this.currentPopup = null;
          },
          isSectionVisible() {
            return true;
          },
          handleChangeTab(index) {
            const tabs = this.sections.map(({id}, i) => `${id || i}`);
            this.activeTab = tabs.indexOf(index) >= 0 ? index : tabs[0];
            this.lastTab = tabs.indexOf(this.activeTab) === tabs.length - 1;
          },
          handleBadge(tab, isValid) {
            this.badges[tab] = isValid;
            this.$forceUpdate();
          },
          isReady() {
            if (!this.currentPopup) {
              return false;
            }
            return this.sections.every(({id}, index) => this.badges[`${id || index}`]);
          }
      }
    }
</script>
